import { FilterModel } from "@Apps/Search/Src/Models/FilterModel";


// this is v1 search
//const accommodationLinkSelector = ".accommodation-card a";

const accommodationLinkSelector = "a.accommodation-card-v2023";

//const searchUrlParameter = "searchUrl";
const scrollPositionParameter = "scrolly";
export function addNewHistoryEntry(search: string): void {
    // update location?
    // note does not contain fragment
    const browserAddressHref = new URL(window.location.pathname, window.location.href).href + "?" + search;
    history.replaceState({ search }, "", browserAddressHref);

}

export function getCurrentUrlAsRelative(): string {

    return location.pathname + location.search;

}

/**
 * will url encode the current url and format it as "returnUrl=[currenturl as encodeUriComponent()];
 * */
export function getCurrentUrlAsReturnUrl(paramName = "returnUrl", includeScroll = false): string {

    let url = getCurrentUrlAsRelative();
    if (includeScroll) {


        if (url.indexOf("?") >= 0) {
            url += "&";
        } else {
            url += "?";
        }

        url += scrollPositionParameter + "=" + 123; // todo:: get scroll.. onload: scroll to

    }

    return paramName + "=" + encodeURIComponent(url);
}

export function addHistoryOnClick(container: HTMLElement, filter: FilterModel, clearAction: undefined | (() => void) = undefined): void {


    container.addEventListener("click", function (e: Event) {

        const s = e.target as HTMLElement;
        if (s && s.classList.contains("btn-favorite")){

            e.preventDefault();
            e.stopPropagation();
            return;
        }

        const link = s.closest(accommodationLinkSelector);
        if (link) {

            e.preventDefault();
            e.stopPropagation();

            const linkHref = link.getAttribute("href")!;



            window.location.href = linkHref + (linkHref.indexOf("?") >= 0 ? "&" : "?") + getCurrentUrlAsReturnUrl();
        }
        else {
            const reset = s.closest("[data-trigger-reset-filter]");
            if (reset) {

                if (clearAction) {
                    clearAction();
                } else {
                    // this is done on the old search, but will in fact not clear all search filters.
                    e.preventDefault();
                    e.stopPropagation();
                    filter.clearCriteria();
                }
            }
        }

    });

}